@use "~theme/typography";
@use "~components/TextInput/tokens" as TextInput;
@use "react-select-overrides" as ReactSelectOverrides;

.errorMessage {
  @include TextInput.error-message;
}

.container {
  margin: 4px 0 8px;
}

.label {
  @include typography.field-label;
}

.dropdownIndicator {
  transition: all 0.3s ease;
}

.dropdownIndicatorOpen {
  transform: rotate(-180deg);
}

.clearIndicator {
  margin-right: 5px;
}

.reactSelect {
  @include ReactSelectOverrides.overrides;
}

.invalid {
  @include ReactSelectOverrides.error-overrides;
}
